import DoctorAmico from '../svg/DoctorAmico';
import InvestmentData from '../svg/InvestmentData';

export function ClinicoIntegratedManagement({ title, description, icon }: { title: string, description: string, icon: string }) {
    return (
        <section className="lg:my-[60px] md:my-[40px] sm:my-[30px] my-[20px] shadow-sm rounded-lg p-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center">

                {/* Illustration */}
                <div className="flex justify-center lg:justify-start motion-safe:animate-float">
                    {
                        icon === 'doctorAmico' ? <DoctorAmico /> : <InvestmentData />
                    }
                </div>

                <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:p-0 p-4">
                    <h3 className="sm:text-[28px] text-[20px] font-bold text-cardtitle leading-tight">
                        {title}
                    </h3>
                    <p className="mt-6 text-carddescription font-medium  sm:text-base text-[15px] lg:text-[24px] leading-relaxed pl-6 ml-auto">
                        {description}
                    </p>
                </div>

            </div>
        </section>
    );
}
